import {Component, OnInit, ViewChild} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-term-pdf-viewer',
  templateUrl: './term-pdf-viewer.component.html',
  styleUrls: ['./term-pdf-viewer.component.css']
})
export class TermPdfViewerComponent implements OnInit {
  @ViewChild('pdfViewer') public pdfViewer;
  urlStream: any;
  title: string;

  constructor(private activeModal: NgbActiveModal,
              public translate: TranslateService) {
  }

  ngOnInit(): void {
  }

  onProgress() {

  }

  accept() {
    this.activeModal.close();
  }
}
